'use client';

import { useLocalization } from '../_providers/localization/LocalizationProvider';
import { cn } from '@/utilities/ui';

export function LanguageSwitcher({ className }: { className?: string }) {
    const { locale, setLocale } = useLocalization();

    return (
        <div className={cn('flex items-center justify-stretch gap-2', className)}>
            <button
                type="button"
                onClick={() => setLocale('en')}
                className={cn(
                    'border-border rounded-full border px-3 py-1 text-xs font-medium transition-colors grow',
                    locale === 'en'
                        ? 'bg-accent text-foreground'
                        : 'text-muted-foreground hover:bg-accent hover:text-foreground',
                )}
            >
                EN
            </button>
            <button
                type="button"
                onClick={() => setLocale('de')}
                className={cn(
                    'border-border rounded-full border px-3 py-1 text-xs font-medium transition-colors grow',
                    locale === 'de'
                        ? 'bg-accent text-foreground'
                        : 'text-muted-foreground hover:bg-accent hover:text-foreground',
                )}
            >
                DE
            </button>
        </div>
    );
}
